import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import "assets/css/App.css";
import ExcelJS from "exceljs";
import axios from "axios";
import {APIURL} from "../../variables/constants";
import {populateAllNLP} from "../../actions";

const SearchQueryDetails = ({id}) => {
   
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const fetchDetails = async () => {
            try {
                axios.get(`${APIURL}?query=getSearchQueryByIdStaging&id=${id}`)
                    .then(response => {
                        setData(response.data);
                    });
            } catch (error) {
                setData(null);
            } finally {
                setLoading(false);
            }
        };

        fetchDetails();
    }, [id]);


    if (loading) return <div className="p-6 bg-white rounded-md shadow-sm">Loading...</div>;
    if (!data || data.error) return <div className="p-6 bg-white rounded-md shadow-sm">No data found for ID: {id}</div>;
     const downloadXlsx = async () => {
    const items = (data.itemresults || "")
      .split(",")
      .map(s => s.trim())
      .filter(Boolean);

    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet("Items");

  
    ws.columns = [
      { header: "Item Results", key: "item", width: 24 },
      { header: "Image",        key: "img",  width: 40 },
    ];
    ws.getRow(1).font = { bold: true };

    
    const blobToBase64 = (blob) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const dataUrl = reader.result;                  
          const base64 = String(dataUrl).split(",")[1];   
          resolve(base64);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const link = `https://images.gabrielny.com/assets/~${item}-1.jpg`;

      
      const rowNumber = i + 2;
      ws.addRow({ item, link });
      ws.getRow(rowNumber).height = 100; 

      try {
        
        const res = await fetch(link, { mode: "cors" });
        const blob = await res.blob();
        const base64 = await blobToBase64(blob);

        const imageId = wb.addImage({ base64, extension: "jpeg" });

        
        ws.addImage(imageId, {
          tl:  { col: 1.2, row: rowNumber - 0.8 },
          ext: { width: 120, height: 90 }, 
        });
      } catch (e) {
       
        console.warn("Image embed failed for", item, e);
      }
    }

    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "items.xlsx";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

    return (
        <div className="grid grid-cols-12 gap-4">
            <div className="col-span-8">
                <div className="bg-transparent h-full overflow-auto p-4 chatRenderer">
                    <div className="mb-4 bg-white p-4 rounded-md">
                        <strong className="text-blue-500">Search Query:</strong>
                        <p className="text-gray-700 mt-1">{data.searchQuery}</p>
                    </div>

                    <div className="mb-4 bg-white p-4 rounded-md">
                        <strong className="text-blue-500">SQL Query:</strong>
                        <pre className="text-sm text-gray-800 mt-2 whitespace-pre-wrap">{data.query}</pre>
                    </div>
                </div>
            </div>

            <div className="col-span-4 grid grid-cols-1 gap-4">
                <div className="p-4 bg-white shadow-sm rounded-md grid grid-cols-1 gap-2">
                    <p><strong>ID:</strong> {data.id}</p>
                    <p><strong>User Login:</strong> {data.userLogin}</p>
                    <p><strong>Date:</strong> {data.queryDate}</p>
                    <p><strong>Status:</strong> {data.status}</p>
                    <p><strong>Result Count:</strong> {data.results}</p>
                    <p><strong>Result Type:</strong> {data.resultType}</p>
                    <p><strong>Clicks:</strong> {data.clicks ?? "N/A"}</p>
                    <p><strong>Exported:</strong> {data.exported ?? "N/A"}</p>
                    <p><strong>Rating:</strong> {data.llmratting ?? "N/A"}</p>
                </div>

                <div className="p-4 bg-white shadow-sm rounded-md">
                    <p className="mb-1 font-semibold">Review:</p>
                    <p>{data.llmreview || "No review available"}</p>
                </div>
            </div>

     <div className="col-span-12 mb-2">
        <button
          onClick={downloadXlsx}
          style={{
            display: "inline-block",
            marginBottom: "30px",
            padding: "10px 15px",
            background: "#1f7ae0",
            color: "white",
            borderRadius: "8px",
            fontWeight: "bold",
          }}
        >
          Download XLSX File
        </button>
      </div>

<table style={{ borderCollapse: "collapse", width: "900%", marginTop: "-50px" }}>
  <thead>
    <tr>
      <th style={{ border: "1px solid #6AD2FF", padding: "20px", textAlign: "left" }}>Item Results</th>
      <th style={{ border: "1px solid #6AD2FF", padding: "20px", textAlign: "left" }}>Image</th>
    </tr>
  </thead>
  <tbody>
    {data.itemresults && data.itemresults.split(",").map((item, index) => {
      const link = `https://images.gabrielny.com/assets/~${item}-1.jpg`;
      return (
        <tr key={index}>
          <td style={{ border: "2px solid #6AD2FF", padding: "5px" }}>{item}</td>
          <td style={{ border: "2px solid #6AD2FF", padding: "5px" }}>
            <img 
              src={link} 
              alt={`Item ${item}`} 
              style={{ width: "120px", height: "auto", borderRadius: "8px" }} 
            />
          </td>
        </tr>
      );
    })}
  </tbody>
</table>


        </div>
    );
};

export default SearchQueryDetails;
